<template>
  <section id="about">
    <div class="row text-center mt-5">
      <div class="col-md-12">
        <h1>{{$t('aboutText.title')}}</h1>
      </div>
    </div>
    <div class="row mx-auto mt-5 mb-5">
      <div class=" col-lg-4 col-sm-12 mb-3  text-center ">
        <img
          src="@/assets/afis.jpeg"
          alt="Zingal Son Kuşak"
          width="350"
          class="img-fluid "
        />
      </div>
      <div class="col-lg-8 col-sm-12">
        <p class="about-text">
         {{$t('aboutText.text')}}
        </p>
        <a
          href="https://www.youtube.com/watch?v=f5xhxRg40Gk"
          target="_blank"
          role="button"
          class="btn btn-outline-dark float-right btn-lg mr-2"
          >{{$t('aboutText.btnText')}}</a
        >
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data(){
    return{
      aboutText : ""
    }
  },
  created(){
    if(localStorage.getItem("lang") ==="en"){
      this.aboutText = "1"
    }else if(localStorage.getItem("lang") ==="tr"){
        this.aboutText = "1"
    }
  }
};
</script>

<style scoped>
* {
  font-family: "Cabin", sans-serif;
  font-weight: 500;
}
h1 {
  font-size: 45px !important;
   font-family: 'Sansita Swashed', cursive;
}
p {
  line-height: 30px;
  font-size: 22px;
}
.btn {
  border-radius: 0px 20px 0px 20px;
}
img {
  -webkit-box-shadow: 0px -3px 85px -10px rgba(0, 0, 0, 0.7);
  -moz-box-shadow: 0px -3px 85px -10px rgba(0, 0, 0, 0.7);
  box-shadow: 0px -3px 85px -10px rgba(0, 0, 0, 0.7);
}
@media only screen and (max-width: 991px) {
  .about-text {
    margin-top:35px;
  }
}
</style>
